// 快速搜索
import SimpleSearch from "@/views/workBench/search/simpleSearch.vue"; //快速搜索页
import DeletedObjects from "@/views/workBench/search/deletedObjects.vue"; //快速搜索页
import DashboardShow from "@/views/workBench/search/dashboardShow.vue"; //快速搜索页
import folderList from "@/views/workBench/search/folderList.vue";

export const Search = [
  {
    path: "/SimpleSearch",
    name: "SimpleSearch",
    component: SimpleSearch,
  },
  {
    path: "/DeletedObjects",
    name: "DeletedObjects",
    component: DeletedObjects,
  },
  {
    path: "/dashboardShow",
    name: "DashboardShow",
    component: DashboardShow,
  },
  {
    path: "/advancedSearch",
    component: () => import("@/views/workBench/search/advancedSearch"),
    meta: {
      keepAlive: true,
    },
  },
  { path: "/folderList", component: folderList },
  {
    path: "/personalSearch",
    component: () => import("@/views/workBench/search/personalSearch"),
  },
  {
    path: "/globalSearch",
    component: () => import("@/views/workBench/search/globalSearch"),
  },
];
